// extracted by mini-css-extract-plugin
export default {"stickable":"wNijeL33K6shP4vveiSw","table":"O43XW_FwQCG1wWS_7BYP","periodsMenu":"xdsiXsRRdvOqoMTzTzz9","monthsMenu":"yiI8ZFcqZ_l1oEv9KQ8Q","placeHolderShimmer":"_FCnuy1OQmHcCbTKvcpd"};